<template>
  <main class="code-perdant-page flex flex-col justify-center items-center min-h-[60vh] py-16 sm:py-24 px-4 sm:px-6">
    <section class="text-center max-w-[676px] mx-auto mb-10 sm:mb-14">
      <h1 class="font-barlow-condensed font-bold text-white uppercase text-4xl sm:text-5xl lg:text-6xl leading-tight mb-4 sm:mb-6">
        Nous sommes navrés,
      </h1>
      <p class="font-barlow-condensed font-bold text-[#FEEFC7] uppercase text-3xl sm:text-4xl lg:text-5xl leading-tight mb-6 sm:mb-8">
        votre code est perdant
      </p>
      <p class="font-barlow-condensed font-bold text-white text-lg sm:text-xl lg:text-2xl leading-snug">
        Mais bonne nouvelle, vous pouvez tenter à nouveau votre chance dès
        demain et jusqu'au 28 février 2027 en achetant un produit Petit
        Navire éligible.
      </p>
    </section>

    <div class="w-full max-w-[1071px] mx-auto grid sm:grid-cols-2 gap-6 sm:gap-8 items-stretch">
      <article class="flex flex-col gap-4">
        <div class="bg-[#2490BE] rounded-lg px-3 sm:px-5 py-4 text-center max-w-[256px] sm:max-w-[375px] w-full mx-auto flex items-center justify-center min-h-[80px] sm:min-h-[90px]">
          <p class="font-barlow-condensed font-bold text-white text-[16px] sm:text-lg lg:text-xl leading-snug">
            Vous pouvez tester un autre<br />
            code si vous le souhaitez.
          </p>
        </div>
        <router-link to="/form" class="block w-full max-w-md mx-auto">
          <img
            src="@/assets/images/perdu/CTA-gauche.svg"
            class="w-full h-auto rounded-[50px] cursor-pointer hover:opacity-95 transition-opacity"
            alt="Je teste un autre produit Petit Navire"
          />
        </router-link>
      </article>

      <article class="flex flex-col gap-4 mt-6 sm:mt-0">
        <div class="bg-[#2490BE] rounded-lg px-3 sm:px-5 py-4 text-center max-w-[256px] sm:max-w-[375px] w-full mx-auto flex items-center justify-center min-h-[80px] sm:min-h-[90px]">
          <p class="font-barlow-condensed font-bold text-white text-[16px] sm:text-lg lg:text-xl leading-snug">
            Ou tentez de gagner un kit dégustation collector avec
            votre ticket de caisse
          </p>
        </div>
        <router-link to="/formig" class="block w-full max-w-md mx-auto">
          <img
            src="@/assets/images/perdu/CTA-droite.svg"
            class="w-full h-auto rounded-[50px] cursor-pointer hover:opacity-95 transition-opacity"
            alt="Je découvre immédiatement si j'ai gagné"
          />
        </router-link>
      </article>
    </div>
  </main>
</template>

<script>
import { getGameResult, isCodePerdantResult } from "@/gameResult";

export default {
  name: "CodePerdantView",
  beforeMount() {
    if (!isCodePerdantResult(getGameResult())) {
      window.location.href = "/form";
    }
  },
};
</script>

<style scoped>
.code-perdant-page {
  background-color: #0d2651;
  background-image: url("@/assets/images/fond-perdu.svg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
</style>
